module.exports = __webpack_public_path__ + "static/media/BestSupplierDANASPICER2020.98089795.png";